export default __webpack_public_path__ + "static/media/bg-fallback-es.d1a05941.png";